function NavigatorButtons({ children }) {
  return <div className="select-none my-6 mx-2 flex flex-row">{children}</div>;
}

export default NavigatorButtons;
